import { gate } from 'hub-http/gates';
export const SMART_COMPOSE = 'smart-compose:initial-access';
export const INBOX_LONG_TASK_REPORT = 'Conversations:InboxLongTaskReport';
export const SIGNATURE_CONTEXTUAL_PROMPT = 'Conversations:EmailSignaturePrompt';
export const WHATSAPP = 'Conversations:WhatsApp';
export const POP_OUT_COMPOSER = 'Communication:Composer:PopOutComposer';
export const ESCALATION_PANEL = 'Zorse:EscalationPanel';
export const GRAPHQL_ASSIGNEES = 'Conversations:GraphQLAssignees';
export const EMAIL_FORWARD_HISTORY = 'Communication:EmailForwardHistory';
export const USER_DEFAULT_FONTS = 'Communication:UserDefaultFonts';
export const HELP_DESK = 'Conversations:HelpDesk';
export const CONVERSATION_SUMMARY = 'Communication:AI:ConversationSummary';
export const AI_ASSISTANT = 'Communication:AI:AIAssistant';
export const CONTACT_PROMOTION = 'HelpDesk:ContactPromotions';
export const REPLY_RECOMMENDATIONS = 'Communication:AI:ReplyRecommendation';
export const CALLING_NEXT_BEST_ACTIONS = 'Calling:Rep:NextBestActions';
export const HELP_DESK_ROUTING_SCOPE_FILTERING = 'HelpDeskRoutingScopeFiltering';
export const REPLY_TO_ALL = gate('Communication:RepMsg:ReplyToAllMessages');